import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonSharedModule } from 'src/app/shared/shared.module';
import { ApprovalBlockComponent } from './approval-block/approval-block.component';
import { PersonPickerComponent } from './person-picker/person-picker.component';
import { RecordFieldDirective } from './record-review';
import { RequestTaskModalComponent } from './request-task-modal/request-task-modal.component';

/**
 * Approvals in the app.
 *
 *  - TaskOpener, which opens a task from the dashboard's Tasks card or an email link: an
 *    approval opens its record's own side panel (RecordPanelOpener, implemented by
 *    BookkeepingModule's RecordPanelService).
 *  - <app-approval-block>, the Approve / Reject band at the bottom of a record's side panel.
 *  - [recordField], which highlights the fields an approval is about.
 *  - TaskRequestService.open(), the "Request approval" dialog.
 *
 * A panel that shows a record provides RecordReviewContext, puts [recordField] on its controls
 * and <app-approval-block> in its footer. Which fields a record type has, and which can be
 * approved on their own, is Admin > Record types.
 */
@NgModule({
  declarations: [
    ApprovalBlockComponent,
    RecordFieldDirective,
    RequestTaskModalComponent,
    PersonPickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgbModule,
    CommonSharedModule
  ],
  exports: [
    ApprovalBlockComponent,
    RecordFieldDirective,
    PersonPickerComponent
  ]
})
export class TasksModule { }
